import { ApplicationConfig, InjectionToken, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {provideHttpClient} from '@angular/common/http';
import { environment } from '../environments/environment';
import {RouteGuardService} from './services/route-guard.service';

export type Environment = typeof environment;
export const ENVIRONMENT = new InjectionToken<Environment>('environment');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    { provide: ENVIRONMENT, useValue: environment },
    RouteGuardService,
  ]
};
